module.exports = __webpack_public_path__ + "static/media/geometry.7083e460.png";